import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchDataDictionaryViewRequest = {
	columns?: string;
	filter?: string;
	ordering?: string;
	viewId: number;
	viewName?: string;
};

export const patchDataDictionaryView = createPatchEndpoint<PatchDataDictionaryViewRequest>(
	(request) => `/api/v3/data-dictionary/views/${request.viewId}`
);
